import { useContext } from 'react';
import { CustomerOrderContext } from './CustomerOrderContext';

const useCustomerOrderContext = () => {
  const customerOrderContext = useContext(CustomerOrderContext);

  if (customerOrderContext === undefined) {
    throw new Error('useCustomerOrderContext must be used within a CustomerOrderContextProvider');
  }

  return customerOrderContext;
};

export default useCustomerOrderContext;
